import PaysFormController from './pays.form.controller';

export default {
    template: require('./pays.form.html'),
    controller: PaysFormController
};
